import React from "react";
import styled from "styled-components";
import { Button, ButtonGroup } from "components/bootstrap";
import { Icon, HoverForHelp } from "components/common";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const StyledButtonGroup = styled(ButtonGroup)`
  margin-left: 5px;
`;
const StyledButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const SearchFilterHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
export const SearchFilterExplanation = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("i", null, "Search filters"), " contain their own query and extend the main query using the ", /* @__PURE__ */ React.createElement("b", null, "AND"), " operator."), /* @__PURE__ */ React.createElement("p", null, "Filters can be saved separately and reused in saved searches and dashboards. Updating a saved filter will automatically affect the search results of searches which include the filter."));
const SearchFilterBanner = ({ onHide, pluggableControls }) => {
  const hasSearchFiltersPlugin = !!pluggableControls.find((control) => control.id === "search-filters");
  if (hasSearchFiltersPlugin) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, "Filters", /* @__PURE__ */ React.createElement(SearchFilterHelp, { title: "Search Filters", trigger: ["click"] }, /* @__PURE__ */ React.createElement(SearchFilterExplanation, null), /* @__PURE__ */ React.createElement("p", null, "Search filters and parameters are available for the enterprise version."), /* @__PURE__ */ React.createElement(StyledButtonBar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onHide, bsSize: "xs" }, "Hide controls"))), /* @__PURE__ */ React.createElement(StyledButtonGroup, null, /* @__PURE__ */ React.createElement(Button, { disabled: true, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "add" })), /* @__PURE__ */ React.createElement(Button, { disabled: true, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "folder" }))));
};
export default SearchFilterBanner;
